import React, { useState } from "react";
import { AiOutlineMinus } from "react-icons/ai";
import { IoMdCloseCircle } from "react-icons/io";
import LoaderSmall from "../shared/LoaderSmall";
import { useRef } from "react";
const imageStoraeKey = `347525e64775187aed4d03329dbe793a`;

const FileTag = ({
  name,
  defaultValue,
  multiple,
  label,
  length,
  required,
  handleRemoveElement,
}) => {
  const [value, setValue] = useState(defaultValue);
  const [preview, setPreview] = useState(defaultValue);
  const [visibility, setVisibility] = useState(true);
  const [loading, setLoading] = useState(false);
  const imgInputRef = useRef();

  const handleFileChange = async (event) => {
    console.log("handle file fired");
    event.preventDefault();
    const image = event.target.files[0];
    const formData = new FormData();
    formData.append("image", image);
    const url = `https://api.imgbb.com/1/upload?key=${imageStoraeKey}`;
    setLoading(true);
    await fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          setValue(result.data.url);
          setLoading(false);
        }
      });

    setPreview(URL.createObjectURL(event.target.files[0]));
  };

  const handleDelete = (e) => {
    e.preventDefault();
    setValue(null);
    setPreview(null);
  };

  return (
    <>
      {visibility ? (
        <div
          key={Math.random()}
          className={visibility ? "flex gap-1 items-center w-full" : "hidden"}
        >
          <div className="w-full ">
            <label
              className="relative flex justify-center w-full h-[20rem]  transition bg-white border-2 border-gray-300 rounded-md appearance-none cursor-pointer hover:border-gray-400 focus:outline-none"
              style={{
                background: `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.9)),url('${preview}')`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <span className="flex flex-col justify-center items-center space-x-2 text-white">
                {loading ? (
                  <LoaderSmall />
                ) : (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-6 h-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                      />
                    </svg>
                    <span className="font-medium">
                      {/* {visibility
                        ? length
                          ? label + " " + length
                          : label
                        : ""} */}
                      Upload Image
                    </span>
                  </>
                )}
              </span>
              <input
                ref={imgInputRef}
                onChange={handleFileChange}
                type="file"
                name={visibility ? name : ""}
                className="hidden"
                src={value ? value : null}
                accept="image/png, image/gif, image/jpeg, image/jpg, image/webp"
              />
            </label>
          </div>
          <div>
            <button
              onClick={handleDelete}
              className="text-red-400 text-[30px] hover:text-red-600 transition duration-150"
            >
              <IoMdCloseCircle />
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default FileTag;
